export const UPDATE_WS = 'update_ws';
export const UPDATE_WS_SUCCESSFUL = 'update_ws_successfull';
export const UPDATE_WS_FAILED = 'update_ws_failed';



